export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-teal-600 text-white">
      <div className="max-w-7xl mx-auto px-6 py-20">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12 mb-16">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/8b1308fd-6fa9-4e78-9243-fa55b35c3949.png" 
                alt="RITMO Logo" 
                className="h-10 w-10 object-contain"
              />
              <h3 className="text-2xl font-light text-white">RITMO, d. o. o.</h3>
            </div>
            <p className="text-teal-100 text-sm leading-relaxed">
              Developing innovative iOS applications that enhance user experience and improve mobile device security.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={scrollToTop} className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('products')} className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Products
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                  Features
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-white text-sm font-semibold mb-4">Information</h4>
            <div className="text-teal-100 text-sm space-y-2">
              <p>Vjekoslava Klaica 26</p>
              <p>Slavonski Brod, 35000</p>
              <p>Croatia</p>
              <p className="mt-4">info@ritmodoo.com</p>
              <p>+1 9379891230</p>
            </div>
          </div>
        </div>

        <div className="border-t border-teal-500 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">iOS</span>
            <span className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">App Store</span>
            <span className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">Support</span>
          </div>

          <p className="text-teal-100 text-sm text-center">
            © 2025 RITMO, d. o. o. All rights reserved.
          </p>

          <div className="flex items-center gap-6">
            <span className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">Privacy</span>
            <span className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap">Terms</span>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-teal-100 text-sm hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}